<script lang="ts">
  import Button from '$lib/ui/Button.svelte';
  import Empty from '$lib/ui/Empty.svelte';
  import { nav } from '$lib/ui/nav.svelte';

  const path = $derived(nav.route.name === 'notfound' ? nav.route.path : '');
</script>

<svelte:head><title>Not found — Jovii</title></svelte:head>

<Empty icon="search" title="There is nothing at {path}" detail="The address does not match anything in here.">
  <Button href="/" variant="primary" icon="back">Back to home</Button>
</Empty>
